import { useRef } from 'react';

import product1 from '../../assets/img/product1.png';
import product2 from '../../assets/img/product2.png';
import product3 from '../../assets/img/product3.png';
import product4 from '../../assets/img/product4.png';
import product5 from '../../assets/img/product5.png';
import product6 from '../../assets/img/product6.png';
import product7 from '../../assets/img/product7.png';
import product8 from '../../assets/img/product8.png';

import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function ProductCard({ title, img, alt }) {
  return (
    <article className="products__card">
      <div className="phone-mockup">
        <div className="phone-screen">
          <img src={img} alt={alt} />
        </div>
      </div>
      <h3 className="products__title">{title}</h3>
    </article>
  );
}

export default function ProductsSection() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const slides = [
    { title: 'Aircraft Detail', img: product1, alt: 'App Screenshot 1' },
    { title: 'Aircraft List', img: product2, alt: 'App Screenshot 2' },
    { title: 'Aircraft Gallery', img: product3, alt: 'App Screenshot 3' },
    { title: 'Country Inventory', img: product4, alt: 'App Screenshot 4' },
    { title: 'Favorites List', img: product5, alt: 'App Screenshot 5' },
    { title: 'Manufacturer Details', img: product6, alt: 'App Screenshot 6' },
    { title: '3D AR View', img: product7, alt: 'App Screenshot 7' },
    { title: 'All Specification', img: product8, alt: 'App Screenshot 8' },
  ];

  return (
    <section className="products section" id="products">
      <div className="container">
        <h2 className="section__title section__title-gradient products__line">
          App <br />
          ScreenShots
        </h2>
        <div className="products__head"></div>
        <div className="swiper-container">
          <button
            ref={prevRef}
            className="products__btn products__btn--prev"
            type="button"
            aria-label="Previous slide"
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          <div className="container products-swiper" style={{ marginTop: '1rem' }}>
            <Swiper
              modules={[Pagination, Navigation]}
              
              spaceBetween={23}
              slidesPerView={4}
              pagination={{ clickable: true }}
              onSwiper={(swiper) => {
                setTimeout(() => {
                  swiper.params.navigation.prevEl = prevRef.current;
                  swiper.params.navigation.nextEl = nextRef.current;

                  swiper.navigation.destroy();
                  swiper.navigation.init();
                  swiper.navigation.update();
                });
              }}
              onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = prevRef.current;
                swiper.params.navigation.nextEl = nextRef.current;
              }}
              breakpoints={{
                0: { slidesPerView: 1.2 },
                576: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
                1280: { slidesPerView: 4 },
              }}
            >
              {slides.map((s) => (
                <SwiperSlide key={s.title}>
                  <ProductCard title={s.title} img={s.img} alt={s.alt} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <button
            ref={nextRef}
            className="products__btn products__btn--next"
            type="button"
            aria-label="Next slide"
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      </div>
    </section>
  );
}
